import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { CheckPoint, ScanIntent, ScanStatus } from '../../model/cardScan'

export interface CardScanState {
  status: ScanStatus
  checkpoint: CheckPoint
}

let scanIntent: ScanIntent | null = null

export const setScanIntent = (intent: ScanIntent | null): void => {
  scanIntent = intent
}

export const getScanIntent = (): ScanIntent | null => {
  return scanIntent
}

export const cardScanInitialState: CardScanState = {
  status: ScanStatus.Initial,
  checkpoint: CheckPoint.CheckoutConfirm,
}

const cardScanSlice = createSlice({
  name: 'cardScan',
  initialState: cardScanInitialState,
  reducers: {
    setCardScanStatus(state: CardScanState, action: PayloadAction<ScanStatus>) {
      state.status = action.payload
    },
    setCardScanCheckpoint(state: CardScanState, action: PayloadAction<CheckPoint>) {
      state.checkpoint = action.payload
    },
  },
})

export const { setCardScanStatus, setCardScanCheckpoint } = cardScanSlice.actions

export default cardScanSlice.reducer
